import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAo7798kmk3bverZqKQV4eVjTZUZuY0vX4",
  authDomain: "fenestra-7a0ac.firebaseapp.com",
  projectId: "fenestra-7a0ac",
  storageBucket: "fenestra-7a0ac.firebasestorage.app",
  messagingSenderId: "342332526772",
  appId: "1:342332526772:web:6f682bb81a4d247667c7e1",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

export const ALLOWED_EMAIL = "ematzyq@gmail.com";
